export const BACKEND_URL = 'https://airsig.kgpl.com'



// WEBPACK FOOTER //
// src/config.js